import React from 'react';
import IconBase from './IconBase';
const ConfirmationIcon = props => React.createElement(IconBase, props, React.createElement("g", {
  fill: "none",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "M30.9,5.9C16.8,5.9,5.4,17.4,5.4,31.5s11.4,25.6,25.5,25.6s25.5-11.5,25.5-25.6S45,5.9,30.9,5.9z"
}), React.createElement("polyline", {
  points: "16.6,26.1 30.5,40 59.8,10.7 "
})));
ConfirmationIcon.displayName = 'ConfirmationIcon';
export default ConfirmationIcon;
//# sourceMappingURL=ConfirmationIcon.js.map